export const HS_ADAPTIVE_NAVIGATION_SPEED_MIN_MULTIPLIER: number = 0.15;
export const HS_ADAPTIVE_NAVIGATION_SPEED_MAX_MULTIPLIER: number = 10;
export const HS_ADAPTIVE_NAVIGATION_SPEED_REFERENCE_DISTANCE: number = 25;

export function hsAdaptiveNavigationSpeedMultiplier(distance: number): number {
  if (!Number.isFinite(distance)) {
    return 1;
  }

  return Math.min(
    HS_ADAPTIVE_NAVIGATION_SPEED_MAX_MULTIPLIER,
    Math.max(HS_ADAPTIVE_NAVIGATION_SPEED_MIN_MULTIPLIER, distance / HS_ADAPTIVE_NAVIGATION_SPEED_REFERENCE_DISTANCE)
  );
}
